import React from "react";

interface PaymentDetailsData {
  payment_type?: string;
  card_brand?: string;
  card_last4?: string;
}

interface LogoSize { width?: number; height?: number; }

interface PaymentDetailsProps {
  data?: PaymentDetailsData | null;
  logos: Record<string, string>;
  className?: string;
  defaultLogoWidth?: number;
  defaultLogoHeight?: number;
  logoSizes?: Record<string, LogoSize | number>;
}

const WALLET_NAMES: Record<string, string> = {
  applepay: "Apple Pay",
  googlepay: "Google Pay",
  paypal: "PayPal",
};

export const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  data,
  logos,
  className = "",
  defaultLogoWidth = 20,
  defaultLogoHeight = 20,
  logoSizes = {},
}) => {
  if (!data) return <span className={className}>-</span>;

  const type = data.payment_type?.toLowerCase();
  const brand = data.card_brand?.toLowerCase();
  const last4 = data.card_last4;

  if (!type && !brand && !last4) return <span className={className}>-</span>;
  const isLink = type === "link";
  const isCard = type === "card";
  const isCashApp = type === "cashapp";

  const renderLogo = (key: string | undefined) => {
    if (!key) return null;
    const src = logos[key];
    if (!src) return null;
    const size = logoSizes[key];
    const w = typeof size === "number" ? size : size?.width ?? defaultLogoWidth;
    const h = typeof size === "number" ? size : size?.height ?? defaultLogoHeight;
    return <img key={key} src={src} alt={key} style={{ width: w, height: h, marginLeft: "3px" }} />;
  };

  const renderContent = () => {
    const el: React.ReactNode[] = [];
    if (isCashApp)
      return [renderLogo("cashapp"), <span key="txt">Cash App Pay</span>];
    if (!isCard) {
      const main = renderLogo(type);
      if (main) el.push(main);
    }
    const brandLogo = renderLogo(brand);
    if (brandLogo) el.push(brandLogo);
    if (last4) el.push(<span key="last4" style={{ marginLeft: "10px" }}>x {last4}</span>);
    if (!brand && !last4) {
      const fallback =
        (type && WALLET_NAMES[type]) ||
        (isLink ? "Link" : isCard ? "Card" : type || "");
      el.push(<span style={{ marginLeft: "5px" }} key="txt">{fallback}</span>);
    }
    return el.length ? el : <span key="fallback">-</span>;
  };

  return (
    <div
      className={className}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      {renderContent()}
    </div>
  );
};
